export default __webpack_public_path__ + "static/media/re2.76910776.jpeg";